import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createEvent } from '../api/events';
import EventForm from '../components/EventForm';
import { useAuth } from '../contexts/AuthContext';

function NewEvent() {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/signin');
    } else if (!isAdmin) {
      navigate('/events');
    }
  }, [isAuthenticated, isAdmin, navigate]);

  if (!isAuthenticated || !isAdmin) return null;

  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      await createEvent(formData);
      navigate('/events');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="new-event">
      <Link to="/events" className="back-link">← Back to Events</Link>
      <h1>Create New Event</h1>
      <EventForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}

export default NewEvent;
